<form class="autocomplete-filter-wrapper">
    <ng-container *ngIf="autoCompleteList?.length!>0; else noTerminals">
        <div class="filter-wrapper">
            <div class="custom-select">
                <div class="type-list-wrapper">
                    <div class="input-with-image">
                        <img class="search scale-img" src="/assets/images/cards/search.svg">
                        <input class="row center" [formControl]="searchControl"
                            [placeholder]="'search.searchSmartQuestions' | translate">
                    </div>
                    <div class="autocomplete-results-wrapper">
                        <!-- <div class="autocomplete-list-item-select type-list-item">
                            <div class="custom-checkbox" (click)="selectAll()">
                                <div class="choose" [ngClass]="{'selected': isSelectAll }">
                                    <div class="inner-selected">
                                        <img src="/assets/images/auto-fill/vi.svg">
                                    </div>
                                </div>
                                <div class="option-name">
                                    <div claas="name">select all</div>
                                </div>
                            </div>
                        </div> -->
                        <div (click)="addItem($event,option)" class="autocomplete-list-item-select type-list-item"
                            *ngFor="let option of filteredOptions | async">
                            <div class="custom-checkbox">
                                <div class="choose" (click)="addItem($event,option)"
                                    [ngClass]="{'selected': option.completed }">
                                    <div class="inner-selected">
                                        <img src="/assets/images/auto-fill/vi.svg">
                                    </div>
                                </div>
                                <div (click)="addItem($event,option)">
                                    <div class="option-name">
                                        <div class="table-item">
                                            <div class="user">
                                                <p *ngIf="option.firstName?.charAt(0)">
                                                    {{option.firstName!.charAt(0).toUpperCase() }}</p>
                                                <p *ngIf="option.lastName?.charAt(0)">{{
                                                    option.lastName!.charAt(0).toUpperCase()}}</p>
                                            </div>
                                        </div>
                                        <div claas="name">{{option.firstName}} {{option.lastName}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <button class="row center side-padding" (click)="apply()" [disabled]="!this.flag"
            translate="">filter.apply</button> -->
    </ng-container>
    <ng-template #noTerminals>
        <div class="filter-wrapper">
            <div class="all">
                הכל
            </div>
        </div>
    </ng-template>
</form>